import { zodResolver } from "@hookform/resolvers/zod";
import { Box, Button, useTheme } from "@mui/material";
import type { FC, FormEvent } from "react";
import { useForm } from "react-hook-form";
import {
	type NewFolderFormInput,
	type NewFolderFormOutput,
	newFolderFormSchema,
} from "web_myplann/Portfolio/Forms/NewFolderForm/newFolderFormSchema";
import { FlatRowFormStackedInput } from "web_myplann/Shared/Components/FlatRow/FlatRowFormStackedInput";

type Props = {
	label: string;
	placeholder: string;
	submitLabel: string;
	onSubmit: (title: string) => void;
};

export const NewFolderForm: FC<Props> = ({
	label,
	placeholder,
	submitLabel,
	onSubmit,
}) => {
	const form = useForm<NewFolderFormInput, unknown, NewFolderFormOutput>({
		resolver: zodResolver(newFolderFormSchema),
		defaultValues: { title: "" },
		mode: "onChange",
	});
	const { spacingTokens } = useTheme();

	const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.stopPropagation();
		form.handleSubmit(({ title }) => onSubmit(title))(event);
	};

	return (
		<Box component="form" onSubmit={handleSubmit}>
			<FlatRowFormStackedInput
				control={form.control}
				name="title"
				label={label}
				placeholder={placeholder}
				isLast
			/>
			<Box px={spacingTokens.lg} py={spacingTokens.lg}>
				<Button
					type="submit"
					variant="primary"
					disabled={!form.formState.isValid}
				>
					{submitLabel}
				</Button>
			</Box>
		</Box>
	);
};
